import { AntSekelton } from "@/Component/Skeleton";
import { Select } from "antd";
import React from "react";
import { cn } from "@/utils/helpers";

export const AntSelect = (props) => {
  const {
    loading,
    size = "large",
    styles,
    allowClear = true,
    className,
    ...restProps
  } = props;

  if (loading) {
    return <AntSekelton.Input />;
  }
  return (
    <Select
      className={cn("ant-select--match-input-height", className)}
      size={size}
      style={{ width: "100%", ...(restProps?.style ?? {}) }}
      styles={{
        selector: {
          borderRadius: "0.75rem",
          alignItems: "center",
          ...(styles?.selector ?? {}),
        },
        ...(styles ?? {}),
      }}
      {...restProps}
      allowClear={allowClear}
      value={restProps.value ?? undefined}
    />
  );
};
